module.exports = __webpack_public_path__ + "img/Reassign.413301c9.svg";